export const getAnswerCardByIdWithKnowledgeAreasQuery = `query getAnswerCardWithKnowledgeAreas($id: Int!) {
    item: prodigio_answer_cards_by_pk(id: $id) {
      id
      realizationMode: realization_mode
      status
      questionsTotal: questions_total
      points: answer_card_questions_aggregate(where: {hit: {_eq: true}, deleted: {_is_null: true}}) {
        aggregate {
          sum {
            points
          }
        }
      }
      exerciseList: exercise_list {
        id
        title
        type
        points: items_aggregate(where: {deleted: {_is_null: true}, id_knowledge_area: {_is_null: false}}) {
          aggregate {
            sum {
              points
            }
          }
        }
        exam_day {
          knowledge_areas(distinct_on: [id_knowledge_area]) {
            id: id_knowledge_area
            order
            knowledge_area {
              name
              color
            }
          }
        }
        items(where: {deleted: {_is_null: true}, id_knowledge_area: {_is_null: false}}, order_by: {order: asc}) {
          id
          question {
            id
            question_type
          }
          id_knowledge_area
        }
      }
      student {
        id
        person {
          name
        }
      }
    }
  }`;
